const INITIAL_STATE = {
  blocks: [],
  signedExtrinsicsCount: 0,
  transfersCount: 0,
  totalIssuance: null,
  holdersCount: null,
  totalCirculation: null,
  lockedValue: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_BLOCK_LIST":
      return { ...state, blocks: action.payload };
    case "SET_SIGNED_EXTRINSICS_COUNT":
      return { ...state, signedExtrinsicsCount: action.payload };
    case "SET_TRANSFERS_COUNT":
      return { ...state, transfersCount: action.payload };
    case "SET_TOTAL_ISSUANCE":
      return { ...state, totalIssuance: action.payload };
    case "SET_HOLDERS_COUNT":
      return { ...state, holdersCount: action.payload };
    case "total_circulation":
      return { ...state, totalCirculation: action.payload };
    case "locked_value":
      return { ...state, lockedValue: action.payload };
    default:
      return state;
  }
}
